import { render, staticRenderFns } from "./BasicCard.vue?vue&type=template&id=e3ef55d8&scoped=true"
import script from "./BasicCard.vue?vue&type=script&lang=js"
export * from "./BasicCard.vue?vue&type=script&lang=js"
import style0 from "./BasicCard.vue?vue&type=style&index=0&id=e3ef55d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ef55d8",
  null
  
)

export default component.exports